import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { applyMask } from '@/masks';

import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink';
import Icon from '@/components/Icon';

import successful from 'images/billing/ava-successful.svg';
import tokenIntegrations from 'images/billing/agendor-integracao-token.gif';

const propTypes = {
  fromCheckout: PropTypes.bool
};

const defaultProps = {
  fromCheckout: false
};

const AVA_PHONE = '1151944866';

function ActivateAvaContent({ fromCheckout }) {
  const message = 'Quero ativar a minha Ava.';
  const encodedText = encodeURIComponent(message);
  const urlRedirect = `https://web.whatsapp.com/send?phone=${AVA_PHONE}&text=${encodedText}`;

  const handleTalkWithAva = () => window.open(urlRedirect, '_blank');
  const learnMoreUrl = 'https://ajuda.agendor.com.br/pt-BR/collections/12159857-ava-assistente-virtual';

  return (
    <div className='px-8'>
      <div className='px-3'>
        { fromCheckout && <img src={successful} className='mb-2' /> }
        <h1>Falta pouco para ativar a Ava!</h1>
        <div className='text-dark-gray fw-bold mt-3 mb-2'>
          <div>
            Envie uma mensagem para o WhatsApp da Ava em
          </div>
          <span className='text-primary'><u>{applyMask(AVA_PHONE, 'phone')}</u></span>
          <span>{' '}para ativar sua integração.</span>
          <br/><br/>
          <div>
            Lembre-se: tenha em mãos o seu token da API!
          </div>
          <div>
            Ele será necessário para concluir o processo.
          </div>
        </div>

        <div className='feature-list__item'>
          <img className='item-image' src={tokenIntegrations} />
        </div>

        {
          fromCheckout
            ? (
              <Button
                className='mb-2 mt-8 width-5'
                onClick={handleTalkWithAva}
                size='sm'
              >
                <Icon name='whatsapp' className='me-1' />
                Falar com a Ava
              </Button>
            )
            : (
              <CopyToClipboard text={urlRedirect}>
                <Button className='mb-2 mt-8 width-5' size='sm'>
                  <Icon name='copy' className='me-1' />
                  Copiar link de convite
                </Button>
              </CopyToClipboard>
            )
        }
        <Button
          className='width-5 text-darker-gray'
          as={ExternalLink}
          target={'_blank'}
          href={learnMoreUrl}
          variant='light'
          size='sm'
        >
          <Icon name='external-link' className='me-1' />
          Saiba mais
        </Button>
      </div>
    </div>
  );
}

ActivateAvaContent.propTypes = propTypes;
ActivateAvaContent.defaultProps = defaultProps;

export default ActivateAvaContent;
